var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.onLine)?_c('div',{staticClass:"rounded",attrs:{"id":"app"}},[_c('div',{staticClass:"text-danger"},[_c('div',{staticClass:""},[_c('span',{},[_c('i',{staticClass:"bi bi-wifi-off",style:({ fontSize: '4em !important' })})])]),_c('br'),_c('span',[_vm._v(" Aucune connexion Internet, merci de réessayer. ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }